import React, { useState, useEffect } from "react";
import LockIcon from "@atlaskit/icon/core/lock-locked";
import PreferencesIcon from "@atlaskit/icon/core/customize";
import QuestionCircleIcon from "@atlaskit/icon/core/question-circle";
import {
  SideNavigation,
  Section,
  NavigationHeader,
  Header,
  NavigationContent,
  LinkItem,
} from "@atlaskit/side-navigation";
import { useNavigate } from "react-router-dom";
import TableIcon from "@atlaskit/icon/core/table";
import { selectFlow, setEditorSaved } from "../redux/actions/integrationActions";
import { useDispatch, useSelector } from "react-redux";
import { newFlow } from "../common/factory/flow.factory";
import BugIcon from "@atlaskit/icon/core/bug";
import { useLocation } from "react-router-dom";
import NotificationIcon from "@atlaskit/icon/core/notification";
import ConfirmModal from "../common/components/ConfirmModal";
import CreditCardIcon from "@atlaskit/icon/core/credit-card";
import { extractNavPath } from "../connections/atlassian/jira/jiraPathExtractor";
import RoadmapIcon from "@atlaskit/icon/core/roadmap";
import CameraIcon from "@atlaskit/icon/core/camera";
import Button from "@atlaskit/button/new";
import { useCustomerMessage } from "../common/hooks/useCustomerMessage";

const MainNav = ({ onToggleCollapse = () => {} }) => {
  const { message, isVisible } = useCustomerMessage();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const appWebLocation = useSelector((state) => state.jira.appWebLocation);

  //confirmation on drafts
  const saved = useSelector((state) => state.integration.saved);
  const [isOpen, setOpen] = useState(false);
  const [navPath, setNavPath] = useState("/");
  const flow = useSelector((state) => state.integration.flow);

  const onConfirmModalNavigate = (id) => {
    dispatch(setEditorSaved(true));
    dispatch(selectFlow(newFlow()));
    navigate(navPath);
    setOpen(false);
  };
  const onCloseNavigateModal = () => {
    setOpen(false);
  };

  const onNavigate = (path) => {
    if (saved) {
      dispatch(selectFlow(newFlow()));
      navigate(path);
    } else {
      setNavPath(path);
      setOpen(true);
    }
  };
  /**
   * ROUTE OUTSIDE IFRAM
   */
  useEffect(() => {
    const routedPath = extractNavPath(appWebLocation);
    if (routedPath) {
      onNavigate(routedPath);
    }
  }, [appWebLocation]);

  return (
    <>
      {" "}
      <ConfirmModal
        action="discard changes"
        targetName={flow.name}
        targetId={flow.id}
        isOpen={isOpen}
        onAction={onConfirmModalNavigate}
        onClose={onCloseNavigateModal}
      />
      <SideNavigation label="project">
        <NavigationHeader>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <LinkItem onClick={() => onNavigate("/")} style={{ flex: 1 }}>
              <Header>Integrations Hub</Header>
            </LinkItem>
            <Button appearance="subtle-link" spacing="none" onClick={onToggleCollapse}>
              Collapse
            </Button>
          </div>
        </NavigationHeader>
        <NavigationContent>
          <LinkItem
            onClick={() => onNavigate("/integration")}
            iconBefore={<PreferencesIcon label="" />}
            isSelected={location.pathname.includes("/integration")}
          >
            Integrations
          </LinkItem>
          <LinkItem
            onClick={() => onNavigate("/credential")}
            iconBefore={<LockIcon label="" />}
            isSelected={location.pathname.includes("/credential")}
          >
            Credentials
          </LinkItem>
          <LinkItem
            onClick={() => onNavigate("/log")}
            iconBefore={<TableIcon label="" />}
            isSelected={location.pathname.startsWith("/log")}
          >
            Log
          </LinkItem>
          <LinkItem
            onClick={() => onNavigate("/notifications")}
            iconBefore={<NotificationIcon label="" />}
            isSelected={location.pathname.includes("/notifications")}
          >
            Notifications
          </LinkItem>
          <LinkItem
            onClick={() => onNavigate("/backups")}
            iconBefore={<CameraIcon label="" />}
            isSelected={location.pathname.startsWith("/backups")}
          >
            Backup & Restore
          </LinkItem>
          <Section title="Tools">
            <LinkItem
              onClick={() => onNavigate("/jsonpath")}
              iconBefore={<BugIcon label="" />}
              isSelected={location.pathname.includes("/jsonpath")}
            >
              JSON Path Test
            </LinkItem>
            <LinkItem
              onClick={() => onNavigate("/encodedecode")}
              iconBefore={<BugIcon label="" />}
              isSelected={location.pathname.includes("/encodedecode")}
            >
              Encode / Decode
            </LinkItem>
          </Section>
          <Section title="Help">
            <LinkItem
              href="https://rixter.atlassian.net/wiki/spaces/RIFJ/overview"
              target="_blank"
              iconBefore={<QuestionCircleIcon label="" />}
            >
              Documentation
            </LinkItem>
            <LinkItem
              href="https://rixter.atlassian.net/servicedesk/customer/portal/2"
              target="_blank"
              iconBefore={<QuestionCircleIcon label="Support" />}
            >
              Support
            </LinkItem>
            <LinkItem onClick={() => onNavigate("/license")} target="_blank" iconBefore={<CreditCardIcon label="License" />}>
              License
            </LinkItem>
            <LinkItem
              href="https://rixter.atlassian.net/wiki/spaces/RIFJ/pages/1668120604/Releases+Roadmap"
              target="_blank"
              iconBefore={<RoadmapIcon label="" />}
            >
              Roadmap
            </LinkItem>
          </Section>
        </NavigationContent>
        {isVisible && (
          <div
            style={{
              padding: "8px 16px 12px",
              fontSize: "12px",
              color: "#974F0C",
              borderTop: "1px solid #F4F5F7",
              wordBreak: "break-word",
            }}
          >
            {message}
          </div>
        )}
      </SideNavigation>
    </>
  );
};
export default MainNav;
